import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Sidebar from './side/Sidebar';
import Pagination from './side/Pagination';
import '../css/InquiryManagement.css';
import { SERVER_URL } from '../../config/config';
import { useNavigate } from 'react-router-dom';
import SearchBox from './side/SearchBox';


const InquiryManagement = () => {
  const [inquiries, setInquiries] = useState([]);
  const [showUnanswered, setShowUnanswered] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const itemsPerPage = 5; // 페이지당 항목 수
  const navigate = useNavigate();

  useEffect(() => {
    fetchInquiries();
  }, [currentPage, showUnanswered, searchTerm]);

  const fetchInquiries = async () => {
    try {
      // 검색어 유무에 따라 다른 엔드포인트 사용
      const url = searchTerm 
        ? `${SERVER_URL}/admin/inquiry/search` 
        : `${SERVER_URL}/admin/inquiry`;

      const params = {
        admin_id: localStorage.getItem('adminId')
      };

      // 검색 시에만 keyword 파라미터 추가
      if (searchTerm) {
        params.keyword = searchTerm;
      }

      const response = await axios.get(url, { params });

      if (response.data.result_code === 200) {
        let filteredInquiries = response.data.inquirys;
        if (showUnanswered) {
          filteredInquiries = filteredInquiries.filter(inquiry => !inquiry._answered);
        }
        setInquiries(filteredInquiries);
        setTotalCount(filteredInquiries.length);
      }
    } catch (error) {
      console.error('Error fetching inquiries:', error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  };

  // 현재 페이지의 항목들만 가져오기
  const getCurrentItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return inquiries.slice(startIndex, endIndex);
  };

  // 총 페이지 수 계산
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  const handleInquiryClick = (inquiryId) => {
    navigate(`/admin/inquiry/${inquiryId}`);
  };

  return (
    <div className="user-management">
      <div className="content-wrapper">
        <Sidebar />
        <div className="main-content">
          <div className="header-section">
            <h1>{showUnanswered ? '답변 대기 문의' : '전체 문의'}</h1>
            <div className="inquiry-controls">
              <SearchBox
                onChange={e => setSearchTerm(e.target.value)}
                value={searchTerm}
                placeholder="제목 , 작성자 검색"
                className="search-box"
              />

              <label className="unanswered-toggle">
                <input
                  type="checkbox"
                  checked={showUnanswered}
                  onChange={(e) => {
                    setShowUnanswered(e.target.checked);
                    setCurrentPage(1);
                  }}
                />
                답변 대기 문의만 보기
              </label>
            </div>
          </div>

          <div className="table-container">
            <div className="header-row">
              <span>제목</span>
              <span>작성자</span>
              <span>작성일</span>
              <span>상태</span>
            </div>

            <div className="data-entries">
              {getCurrentItems().length === 0 ? (
                <div className="table-row">
                  <span className="cell" style={{ fontSize: '18px', gridColumn: '1 / -1', color: '#888' }}>
                    검색된 문의가 없습니다.
                  </span>
                </div>
              ) : (
                getCurrentItems().map((inquiry) => (
                  <div 
                    key={inquiry.inquiry_id} 
                    className="table-row"
                    onClick={() => handleInquiryClick(inquiry.inquiry_id)}
                  >
                    <span className="cell" style={{ justifyContent: 'left' }}>{inquiry.title}</span>
                    <span className="cell">{inquiry.username}</span>
                    <span className="cell">{formatDate(inquiry.inquiry_date)}</span>
                    <span className="cell">
                      {inquiry._answered ? (
                        <span className="status-answered">답변완료</span>
                      ) : (
                        <span className="status-pending">답변대기</span>
                      )}
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>

          {totalPages > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default InquiryManagement; 